<div class="text-center">
  <app-ng-icon [name]="iconName" class="text-[50px] text-fg-faint"></app-ng-icon>
  <h3 class="mt-2 text-sm font-semibold text-fg-muted">{{ heading }}</h3>
  <p class="mt-1 text-sm text-fg-secondary">{{ subheading }}</p>
</div>
